<template>
    <div class="text-center">
        <v-menu
            v-model="reportsmenu"
            bottom
            left
            :max-width="$isDesktop() ? '640px' : '90%'"
            max-height="90%"
            offset-y
            origin="top right"
            :close-on-content-click="false"
            transition="scale-transition"
            :disabled="menueDisabled === true"
        >
            <template v-slot:activator="{ attrs, on }">
                <v-btn raised elevation="1" min-width="0" text v-bind="attrs" v-on="on">
                    <v-icon>mdi-airplane</v-icon>
                </v-btn>
            </template>

            <v-card style="">
                <v-card-title class="headline">
                    <p class="pl-7 mb-8 mt-8">Reports</p>
                </v-card-title>
                <v-card-subtitle>
                    <v-tabs v-model="input_tabIndex" center-active>
                        <v-tab>
                            <v-icon left> mdi-clock-outline </v-icon>
                            Block Hours
                        </v-tab>
                        <v-tab>
                            <v-icon left> mdi-calendar </v-icon>
                            Flight Schedule
                        </v-tab>
                        <v-tab>
                            <v-icon left> mdi-arrow-collapse </v-icon>
                            Swap Logs
                        </v-tab>
                        <v-tab
                            v-if="
                                (!get_Shared_isUserAllowedToUse('READONLY') &&
                                    get_Shared_isUserAllowedToUse('ADMIN')) ||
                                get_Shared_isUserAllowedToUse('FUEL')
                            "
                        >
                            <v-icon left> mdi-gas-station-outline </v-icon>
                            Fuel Calculator
                        </v-tab>
                        <!-- <v-tab>
                            <v-icon left> mdi-airplane-outline </v-icon>
                            SITA Flights
                        </v-tab> -->
                    </v-tabs>
                </v-card-subtitle>

                <v-tabs-items v-model="input_tabIndex" style="max-height: 400px; overflow: auto">
                    <v-tab-item>
                        <v-card style="padding: 16px 16px" flat>
                            <v-form ref="form" v-model="valid" lazy-validation>
                                <v-card-text>
                                    <v-select
                                        v-model="input_AircraftConfigs"
                                        multiple
                                        :items="get_AircraftConfigs"
                                        :rules="[rules.req(input_AircraftConfigs)]"
                                        item-value="id"
                                        item-text="code"
                                        prepend-icon="mdi-airplane"
                                        clearable
                                        style="width: 100%"
                                    >
                                        <template v-slot:label>
                                            <p>
                                                Aircraft Configs
                                                <span style="color: red; font-size: 1.4rem">*</span>
                                            </p>
                                        </template>
                                    </v-select>

                                    <v-menu
                                        ref="dates_dateMenuBlock"
                                        v-model="datemenu_dateRangeBlockHours"
                                        style="margin-top: 18px"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-combobox
                                                v-model="formattedDateRangeBlockHours"
                                                multiple
                                                class="sdr-custom-dates-combobox"
                                                chips
                                                v-bind="attrs"
                                                prepend-icon="mdi-calendar"
                                                :rules="[rules.req(input_dateRangeBlockHours)]"
                                                readonly
                                                v-on="on"
                                            >
                                                <template v-slot:label>
                                                    Date Range
                                                    <span style="color: red; font-size: 1.4rem">*</span>
                                                </template>
                                            </v-combobox>
                                        </template>
                                        <v-date-picker
                                            v-model="input_dateRangeBlockHours"
                                            :first-day-of-week="1"
                                            no-title
                                            range
                                        >
                                            <v-spacer />
                                            <v-btn text color="primary" @click="datemenu_dateRangeBlockHours = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text color="primary" @click="onClick_datemenuBlockHours_OK">
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-card-text>
                            </v-form>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card style="padding: 16px 16px" flat>
                            <v-form ref="form" v-model="valid" lazy-validation>
                                <v-card-text>
                                    <v-menu
                                        ref="dates_dateMenuFlight"
                                        v-model="datemenu_dateRangeFlightSchedule"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-combobox
                                                v-model="formattedDateRangeFlightSchedule"
                                                multiple
                                                class="sdr-custom-dates-combobox"
                                                chips
                                                v-bind="attrs"
                                                prepend-icon="mdi-calendar"
                                                :rules="[rules.req(input_dateRangeFlightSchedule)]"
                                                readonly
                                                v-on="on"
                                            >
                                                <template v-slot:label>
                                                    Date Range
                                                    <span style="color: red; font-size: 1.4rem">*</span>
                                                </template>
                                            </v-combobox>
                                        </template>
                                        <v-date-picker
                                            v-model="input_dateRangeFlightSchedule"
                                            :first-day-of-week="1"
                                            no-title
                                            range
                                        >
                                            <v-spacer />
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="datemenu_dateRangeFlightSchedule = false"
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn text color="primary" @click="onClick_datemenuFlightSchedule_OK">
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-card-text>
                                <div
                                    v-if="
                                        !get_Shared_isUserAllowedToUse('READONLY') &&
                                        get_Shared_isUserAllowedToUse('ADMIN')
                                    "
                                    style="display: flex"
                                >
                                    <v-checkbox
                                        v-model="checkbox_includeSlots"
                                        label="Include Slots"
                                        @change="onChange_setSlotReportCheckbox('includeSlots')"
                                    />
                                    <v-checkbox
                                        v-model="checkbox_onlyMissingSlots"
                                        style="margin-left: 14px"
                                        label="Only missing/mismatching Slots"
                                        @change="onChange_setSlotReportCheckbox('missingSlots')"
                                    />
                                </div>
                            </v-form>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card style="padding: 16px 16px" flat>
                            <v-form ref="form" v-model="valid" lazy-validation>
                                <v-card-text>
                                    <p>Click 'Show' to get all open Swap Logs</p>
                                </v-card-text>
                            </v-form>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card style="padding: 16px 16px" flat>
                            <v-form ref="form" v-model="valid" lazy-validation>
                                <v-card-text>
                                    <v-select
                                        v-model="input_fuelCalculator_AircraftConfigs"
                                        multiple
                                        :items="get_AircraftConfigs"
                                        :rules="[rules.req(input_fuelCalculator_AircraftConfigs)]"
                                        item-value="idAircraft"
                                        item-text="name"
                                        prepend-icon="mdi-airplane"
                                        clearable
                                    >
                                        <template v-slot:label>
                                            <p>
                                                Aircraft Configs
                                                <span style="color: red; font-size: 1.4rem">*</span>
                                            </p>
                                        </template>
                                    </v-select>

                                    <v-menu
                                        ref="fuelCalculator_dates_dateMenuFlight"
                                        v-model="fuelCalculator_datemenu_dateRangeBlockHours"
                                        style="margin-top: 18px"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-combobox
                                                v-model="fuelCalculator_formattedDateRangeBlockHours"
                                                multiple
                                                class="sdr-custom-dates-combobox"
                                                chips
                                                v-bind="attrs"
                                                prepend-icon="mdi-calendar"
                                                :rules="[rules.req(input_fuelCalculator_dateRangeBlockHours)]"
                                                readonly
                                                v-on="on"
                                            >
                                                <template v-slot:label>
                                                    Date Range
                                                    <span style="color: red; font-size: 1.4rem">*</span>
                                                </template>
                                            </v-combobox>
                                        </template>
                                        <v-date-picker
                                            v-model="input_fuelCalculator_dateRangeBlockHours"
                                            :first-day-of-week="1"
                                            no-title
                                            range
                                        >
                                            <v-spacer />
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="fuelCalculator_datemenu_dateRangeBlockHours = false"
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn text color="primary" @click="onClick_datemenuFuelCalculator_OK">
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                    <v-text-field
                                        v-model="input_tonPerBlockHour"
                                        prepend-icon="mdi-barrel-outline"
                                        :rules="[rules.req(input_tonPerBlockHour)]"
                                    >
                                        <template v-slot:label>
                                            Metric Ton / Block Hour
                                            <span style="color: red; font-size: 1.4rem">*</span>
                                        </template>
                                    </v-text-field>
                                    <v-text-field
                                        v-model="input_pricePerTonne"
                                        prepend-icon="mdi-cash-multiple"
                                        :rules="[rules.req(input_pricePerTonne)]"
                                    >
                                        <template v-slot:label>
                                            Price (€) / Metric Ton
                                            <span style="color: red; font-size: 1.4rem">*</span>
                                        </template>
                                    </v-text-field>

                                    <div ref="calculatedPrice" style="text-align: end">
                                        <div style="">Calculated Block Hours: {{ calculatedBlockHoursSum }}h</div>
                                        <div>Calculated Tons: {{ calculatedTons }}</div>
                                        <h3
                                            :style="{
                                                textDecorationLine: calculatedPrice !== 0 ? 'underline' : 'none',
                                                textDecorationStyle: calculatedPrice !== 0 ? 'double' : 'none',
                                            }"
                                        >
                                            Calculated Price: {{ calculatedPrice }}€
                                        </h3>
                                    </div>
                                </v-card-text>
                            </v-form>
                        </v-card>
                    </v-tab-item>
                    <!-- <v-tab-item>
                        <v-card style="padding: 16px 16px" flat>
                            <v-form ref="form" v-model="valid" lazy-validation>
                                <sdr-sita-menue ref="sitamenu" />
                            </v-form>
                        </v-card>
                    </v-tab-item> -->
                </v-tabs-items>

                <!-- >>> Action Buttons -->
                <v-card-actions
                    style="position: absolute, bottom: 0px, background-color: white, padding-bottom: 0.71rem"
                >
                    <v-spacer />
                    <v-btn
                        style="width: 120px"
                        depressed
                        elevation="1"
                        outlined
                        color="#ab3b7a"
                        @click="reportsmenu = false"
                    >
                        Close
                    </v-btn>
                    <v-btn style="width: 120px" depressed elevation="1" color="primary" @click="onClick_download">
                        <div v-if="input_tabIndex < 2">Download</div>
                        <div v-else-if="input_tabIndex === 2">Show</div>
                        <div v-else-if="input_tabIndex === 3">Calculate</div>
                        <div v-if="input_tabIndex === 4">Download</div>
                    </v-btn>
                </v-card-actions>
                <!-- <<< Action Buttons -->
            </v-card>
        </v-menu>
        <sdr-swap-logs v-if="swapLogsDialogShown" v-model="swapLogsDialogShown" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import dayjs from 'dayjs';
import { eventBus } from '../../../../main';

import SwapLogs from './components/SwapLogs.vue';
import SitaMenue from './components/SitaMenue.vue';

export default {
    name: 'Reportsmenu',

    /* >>> *************************************************************** / /* Components */
    components: {
        'sdr-swap-logs': SwapLogs,
        'sdr-sita-menue': SitaMenue,
    }, // eo components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: () => ({
        reportsmenu: false,
        menueDisabled: false,
        input_tabIndex: 0,
        // >>> ----------------------- Block Hours
        input_AircraftConfigs: [],
        input_dateRangeBlockHours: [],
        datemenu_dateRangeBlockHours: null,
        // >>> ----------------------- Flight Schedule
        input_dateRangeFlightSchedule: [],
        datemenu_dateRangeFlightSchedule: null,
        checkbox_includeSlots: false,
        checkbox_onlyMissingSlots: false,
        // >>> -----------------------
        rules: {
            req(v) {
                return (v || '').toString().length > 0 || 'Field is required';
            },
        },
        valid: false,
        // >>> ----------------------- Block Hours
        swapLogsDialogShown: false,
        // >>> ----------------------- Fuel Calculator
        input_fuelCalculator_AircraftConfigs: [],
        input_fuelCalculator_dateRangeBlockHours: [],
        fuelCalculator_datemenu_dateRangeBlockHours: null,
        input_tonPerBlockHour: 2.4,
        input_pricePerTonne: 1300,
        calculatedPrice: 0,
        calculatedBlockHoursSum: 0,
        calculatedTons: 0,
        isGlowing: false,
    }), // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: {
        ...mapGetters([
            'get_AircraftConfigs',
            'get_flights_Resources_Filtered',
            'get_Shared_isUserAllowedToUse',
            'get_flights_blockHours',
            'get_flights_StartDate',
            'get_flights_EndDate',
        ]),

        /******************************************************************* 'DateFields Formatter'
         * formattedDateRangeBlockHours{}
         *
         * Desc:
         * Note:
         *
         */
        formattedDateRangeBlockHours: {
            get() {
                const me = this;

                if (me.input_dateRangeBlockHours.length === 2) {
                    //switch dates, so the range is valid
                    if (dayjs(me.input_dateRangeBlockHours[0]).isAfter(dayjs(me.input_dateRangeBlockHours[1]))) {
                        //switch val[0] und val[1]
                        [me.input_dateRangeBlockHours[0], me.input_dateRangeBlockHours[1]] = [
                            me.input_dateRangeBlockHours[1],
                            me.input_dateRangeBlockHours[0],
                        ];
                    }
                }

                me.$toc(
                    '>>> views/people/components/core/ReportsMenue.vue >>> computed/formattedDateRangeBlockHours/get'
                );
                return me.input_dateRangeBlockHours
                    ? [...new Set(me.input_dateRangeBlockHours.map((date) => me.formatDateForTextField(date)))].sort(
                          (a, b) => {
                              return new Date(b.date) - new Date(a.date);
                          }
                      )
                    : [];
            }, // eo function formattedDateRangeBlockHours get()

            set(value) {
                const me = this;

                me.$toc(
                    '>>> views/people/components/core/ReportsMenue.vue >>> computed/formattedDateRangeBlockHours/set'
                );
                me.input_dateRangeBlockHours = value;
                return me.input_dateRangeBlockHours;
            }, // eo function formattedDateRangeBlockHours set()
        }, // eo formattedDateRangeBlockHours{}

        /******************************************************************* 'DateFields Formatter'
         * formattedDateRangeFlightSchedule{}
         *
         * Desc:
         * Note:
         *
         */
        formattedDateRangeFlightSchedule: {
            get() {
                const me = this;

                if (me.input_dateRangeFlightSchedule.length === 2) {
                    //switch dates, so the range is valid
                    if (
                        dayjs(me.input_dateRangeFlightSchedule[0]).isAfter(dayjs(me.input_dateRangeFlightSchedule[1]))
                    ) {
                        //switch val[0] und val[1]
                        [me.input_dateRangeFlightSchedule[0], me.input_dateRangeFlightSchedule[1]] = [
                            me.input_dateRangeFlightSchedule[1],
                            me.input_dateRangeFlightSchedule[0],
                        ];
                    }
                }

                me.$toc(
                    '>>> views/people/components/core/ReportsMenue.vue >>> computed/formattedDateRangeFlightSchedule/get'
                );
                return me.input_dateRangeFlightSchedule
                    ? [
                          ...new Set(me.input_dateRangeFlightSchedule.map((date) => me.formatDateForTextField(date))),
                      ].sort((a, b) => {
                          return new Date(b.date) - new Date(a.date);
                      })
                    : [];
            }, // eo function formattedDateRangeFlightSchedule get()

            set(value) {
                const me = this;

                me.$toc(
                    '>>> views/people/components/core/ReportsMenue.vue >>> computed/formattedDateRangeFlightSchedule/set'
                );
                me.input_dateRangeFlightSchedule = value;
                return me.input_dateRangeFlightSchedule;
            }, // eo function formattedDateRangeFlightSchedule set()
        }, // eo formattedDateRangeFlightSchedule{}

        /******************************************************************* 'DateFields Formatter'
         * fuelCalculator_formattedDateRangeBlockHours{}
         *
         * Desc:
         * Note:
         *
         */
        fuelCalculator_formattedDateRangeBlockHours: {
            get() {
                const me = this;

                if (me.input_fuelCalculator_dateRangeBlockHours.length === 2) {
                    //switch dates, so the range is valid
                    if (
                        dayjs(me.input_fuelCalculator_dateRangeBlockHours[0]).isAfter(
                            dayjs(me.input_fuelCalculator_dateRangeBlockHours[1])
                        )
                    ) {
                        //switch val[0] und val[1]
                        [
                            me.input_fuelCalculator_dateRangeBlockHours[0],
                            me.input_fuelCalculator_dateRangeBlockHours[1],
                        ] = [
                            me.input_fuelCalculator_dateRangeBlockHours[1],
                            me.input_fuelCalculator_dateRangeBlockHours[0],
                        ];
                    }
                }

                me.$toc(
                    '>>> views/people/components/core/ReportsMenue.vue >>> computed/fuelCalculator_formattedDateRangeBlockHours/get'
                );
                return me.input_fuelCalculator_dateRangeBlockHours
                    ? [
                          ...new Set(
                              me.input_fuelCalculator_dateRangeBlockHours.map((date) => me.formatDateForTextField(date))
                          ),
                      ].sort((a, b) => {
                          return new Date(b.date) - new Date(a.date);
                      })
                    : [];
            }, // eo function fuelCalculator_formattedDateRangeBlockHours get()

            set(value) {
                const me = this;

                me.$toc(
                    '>>> views/people/components/core/ReportsMenue.vue >>> computed/fuelCalculator_formattedDateRangeBlockHours/set'
                );
                me.input_fuelCalculator_dateRangeBlockHours = value;
                return me.input_fuelCalculator_dateRangeBlockHours;
            }, // eo function fuelCalculator_formattedDateRangeBlockHours set()
        }, // eo fuelCalculator_formattedDateRangeBlockHours{}
    }, // eof computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Watch */
    watch: {
        /*******************************************************************
         * reportsmenu()
         *
         * Desc:
         * Note:
         *
         */
        reportsmenu(val) {
            const me = this;

            // if menu opens
            if (val) {
                me.input_AircraftConfigs = me.get_flights_Resources_Filtered.map(
                    (flightResource) => flightResource.idAircraft
                );
                me.input_fuelCalculator_AircraftConfigs = me.get_flights_Resources_Filtered.map(
                    (flightResource) => flightResource.idAircraft
                );
                me.input_fuelCalculator_dateRangeBlockHours = [
                    me.get_flights_StartDate.format('YYYY-MM-DD'),
                    me.get_flights_EndDate.format('YYYY-MM-DD'),
                ];

                // reset
                me.calculatedBlockHoursSum = 0;
                me.calculatedTons = 0;
                me.calculatedPrice = 0;

                // trigger event for other menus to close
                eventBus.$emit('menuopen');
            }
        }, // eof reportsmenu()

        /*******************************************************************
         * input_tabIndex()
         *
         * Desc:
         * Note:
         *
         */
        input_tabIndex(val) {
            const me = this;

            me.valid = false;
        }, // eof input_tabIndex()

        /*******************************************************************
         * get_flights_blockHours()
         *
         * Desc:
         * Note:
         *
         */
        get_flights_blockHours(val) {
            const me = this;
            let actualHoursSum = 0,
                tonPerBlockHour = 0,
                pricePerTonne = 0;

            tonPerBlockHour = me.input_tonPerBlockHour.toString().replace(',', '.');
            pricePerTonne = me.input_pricePerTonne.toString().replace(',', '.');

            val.forEach((v) => {
                actualHoursSum += v._actualHours;
            });

            me.calculatedBlockHoursSum = (actualHoursSum / 3600).toFixed(2);
            me.calculatedTons = (tonPerBlockHour * me.calculatedBlockHoursSum).toFixed(2);

            me.calculatedPrice = me.calculatedTons * pricePerTonne;
            me.calculatedPrice = me.numberWithCommas(me.calculatedPrice.toFixed(2));

            setTimeout(function () {
                me.isGlowing = true;
            }, 100);

            setTimeout(function () {
                me.isGlowing = false;
            }, 1600);
        }, // eof get_flights_blockHours()
    }, // eof watch{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
     * Lifecyclehook::created
     *
     * Desc:
     * Note:
     *
     */
    created: function () {
        const me = this;

        me.$toc('>>> views/shared/components/core/ReportsMenue.vue >>> created');
        // if (me.get_Shared_isUserAllowedToUse('ADMIN')) {
        //     me.checkbox_includeSlots = true;
        // }
    }, // eo function created()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: {
        ...mapActions([
            'actn_call_blockHoursDownload',
            'actn_call_flightScheduleDownload',
            'actn_call_getBlockHours',
            'actn_call_getSitaExport',
        ]),

        /******************************************************************* 'Listeners - Emit'
         * Listeners:
         *******************************************************************/

        /*******************************************************************
         * onClick_datemenuBlockHours_OK()
         *
         * Desc:
         * Note:
         *
         */
        onClick_datemenuBlockHours_OK: function (date) {
            this.$refs.dates_dateMenuBlock.save(date);
        }, // eo function onClick_datemenuBlockHours_OK()

        /*******************************************************************
         * onClick_datemenuFlightSchedule_OK()
         *
         * Desc:
         * Note:
         *
         */
        onClick_datemenuFlightSchedule_OK: function (date) {
            this.$refs.dates_dateMenuFlight.save(date);
        }, // eo function onClick_datemenuFlightSchedule_OK()

        /*******************************************************************
         * onClick_datemenuFuelCalculator_OK()
         *
         * Desc:
         * Note:
         *
         */
        onClick_datemenuFuelCalculator_OK: function (date) {
            this.$refs.fuelCalculator_dates_dateMenuFlight.save(date);
        }, // eo function onClick_datemenuFuelCalculator_OK()

        /*******************************************************************
         * onClick_download()
         *
         * Desc: Trigger the download call for a specific document.
         * Note: Based on the tab index.
         * Note: 0 = Block Hours
         * Note: 1 = Flight Schedule
         *
         */
        onClick_download: function () {
            const me = this;
            let payload = null;

            me.$toc('>>> views/people/components/core/ReportsMenue.vue >>> onClick_download');
            if (me.input_tabIndex === 0 && me.$refs.form.validate() === true) {
                payload = me.buildBlockHourDownloadPayload(me.input_dateRangeBlockHours, me.input_AircraftConfigs);
                me.actn_call_blockHoursDownload(payload);
            } else if (me.input_tabIndex === 1 && me.$refs.form.validate() === true) {
                me.actn_call_flightScheduleDownload(me.buildFlightScheduleDownloadPayload());
            } else if (me.input_tabIndex === 2 && me.$refs.form.validate() === true) {
                me.reportsmenu = false;
                me.swapLogsDialogShown = true;
            } else if (me.input_tabIndex === 3 && me.$refs.form.validate() === true) {
                payload = me.buildBlockHourDownloadPayload(
                    me.input_fuelCalculator_dateRangeBlockHours,
                    me.input_fuelCalculator_AircraftConfigs
                );
                me.actn_call_getBlockHours(payload);
            } else if (me.input_tabIndex === 4 && me.$refs.form.validate() === true) {
                me.actn_call_getSitaExport({ query: me.$refs.sitamenu.query });
            }
        }, // eo function onClick_download()

        /*******************************************************************
         * formatDateForTextField()
         *
         * Desc: Modify the date with the utc filter.
         * Note:
         *
         * @param {Object} date (date to format)
         */
        formatDateForTextField: function (date) {
            const me = this;

            me.$toc('>>> views/people/components/core/ReportsMenue.vue >>> formatDateForTextField');
            return me.$options.filters.dayjsUtcDe(date, { showDayName: true });
        }, // eo function formatDateForTextField()

        /*******************************************************************
         * onChange_setSlotReportCheckbox()
         *
         * Desc:
         * Note:
         *
         * @param {Object} date (date to format)
         */
        onChange_setSlotReportCheckbox: function (field) {
            const me = this;

            me.$toc('>>> views/people/components/core/ReportsMenue.vue >>> onChange_setSlotReportCheckbox');
            if (field === 'missingSlots') {
                // me.checkbox_onlyMissingSlots = true;
                me.checkbox_includeSlots = false;
            }
            if (field === 'includeSlots') {
                // me.checkbox_includeSlots = true;
                me.checkbox_onlyMissingSlots = false;
            }
        }, // eo function onChange_setSlotReportCheckbox()

        /*******************************************************************
         * buildBlockHourDownloadPayload()
         *
         * Desc:
         * Note:
         *
         */
        buildBlockHourDownloadPayload: function (dateRange, aircrafts) {
            const me = this;
            let payload = null,
                fromDate = null,
                toDate = null;

            me.$toc('>>> views/people/components/core/ReportsMenue.vue >>> buildBlockHourDownloadPayload');
            if (dateRange) {
                if (dateRange.length === 1) {
                    fromDate = dayjs(dateRange[0]).format('YYYY-MM-DDT00:00:00[Z]');
                    toDate = dayjs(dateRange[0]).format('YYYY-MM-DDT23:59:59[Z]');
                }
                if (dateRange.length === 2) {
                    fromDate = dayjs(dateRange[0]).format('YYYY-MM-DDT00:00:00[Z]');
                    toDate = dayjs(dateRange[1]).format('YYYY-MM-DDT23:59:59[Z]');
                }
            }
            payload = {
                fromDate: fromDate,
                idAircraftConfigs: aircrafts,
                toDate: toDate,
            };

            return payload;
        }, // eo function buildBlockHourDownloadPayload()

        /*******************************************************************
         * buildBlockHourDownloadPayload()
         *
         * Desc:
         * Note:
         *
         */
        buildFlightScheduleDownloadPayload: function () {
            const me = this;
            let payload = null,
                fromDate = null,
                toDate = null;

            me.$toc('>>> views/people/components/core/ReportsMenue.vue >>> buildBlockHourDownloadPayload');
            if (me.input_dateRangeFlightSchedule) {
                if (me.input_dateRangeFlightSchedule.length === 1) {
                    fromDate = dayjs(me.input_dateRangeFlightSchedule[0]).format('YYYY-MM-DDT00:00:00[Z]');
                    toDate = dayjs(me.input_dateRangeFlightSchedule[0]).format('YYYY-MM-DDT23:59:59[Z]');
                }
                if (me.input_dateRangeFlightSchedule.length === 2) {
                    fromDate = dayjs(me.input_dateRangeFlightSchedule[0]).format('YYYY-MM-DDT00:00:00[Z]');
                    toDate = dayjs(me.input_dateRangeFlightSchedule[1]).format('YYYY-MM-DDT23:59:59[Z]');
                }
            }
            payload = {
                fromDate: fromDate,
                toDate: toDate,
                slot: me.checkbox_onlyMissingSlots,
                showSlots: me.checkbox_includeSlots,
            };

            return payload;
        }, // eo function buildBlockHourDownloadPayload()

        numberWithCommas(number) {
            var parts = number.toString().split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            return parts.join(',');
        },
    }, // eof methods()
    /* <<< ****************************************************************/
};
</script>

<style scoped>
.v-card {
    margin-top: 0px;
    margin-bottom: 0px;
}

@keyframes glowing {
    0% {
        box-shadow: 0 0 -10px #82a683;
        transform: scale(1);
    }
    40% {
        box-shadow: 0 0 20px #82a683;
        transform: scale(1.1);
    }
    60% {
        box-shadow: 0 0 20px #82a683;
        transform: scale(1.1);
    }
    100% {
        box-shadow: 0 0 -10px #82a683;
        transform: scale(1);
    }
}

.input-glow {
    animation: glowing 1500ms 1;
}
</style>

<style>
.v-card__subtitle,
.v-card__text,
.v-card__title {
    padding: 0px !important;
}

.v-card__title {
    font-size: 18px;
}

.v-tab--active {
    color: #ab3b7a !important;
}
</style>
